import { render, staticRenderFns } from "./SelectedServiceOverview.vue?vue&type=template&id=81175eb4&scoped=true&"
import script from "./SelectedServiceOverview.vue?vue&type=script&lang=js&"
export * from "./SelectedServiceOverview.vue?vue&type=script&lang=js&"
import style0 from "./SelectedServiceOverview.vue?vue&type=style&index=0&id=81175eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81175eb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81175eb4')) {
      api.createRecord('81175eb4', component.options)
    } else {
      api.reload('81175eb4', component.options)
    }
    module.hot.accept("./SelectedServiceOverview.vue?vue&type=template&id=81175eb4&scoped=true&", function () {
      api.rerender('81175eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/launchService/SelectedServiceOverview.vue"
export default component.exports